/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["app-tax-e-income .FormElement.CheckBoxPadding .FormElement-control .FormElement-checkbox.undefined :nth-child(3){position:relative}app-tax-e-income .textWithTooltip{top:-5px}app-tax-e-income .MarginTop .FormElement-label{margin-top:-4px}"];
export { styles as styles };
